import { zonedEndOfDay, zonedStartOfDay, zonedSubtractDuration } from '@csp/csp-common-date-util';
import { ZonedDateTime } from '@csp/csp-common-model';

export type DateRangeInput = {
  lastDayTimestamp: ZonedDateTime;
  lastDayInclusive?: boolean;
  nrOfDays: number;
};

export type DateRange = {
  fromDate: ZonedDateTime;
  toDate: ZonedDateTime;
};

/**
 * Example: if last day date is 23 and nrOfDays is 3:
 *    with lastDayInclusive = false, date range should be 20 -> 22;
 *    with lastDayInclusive = true, date range should be 21 -> 23;
 */
export const getDateRange = ({ lastDayTimestamp, lastDayInclusive = false, nrOfDays }: DateRangeInput): DateRange => {
  const toDate = zonedEndOfDay(zonedSubtractDuration(lastDayTimestamp, { days: lastDayInclusive ? 0 : 1 }));
  const fromDate = zonedStartOfDay(zonedSubtractDuration(toDate, { days: nrOfDays - 1 }));

  return { fromDate, toDate };
};
